module.exports = __webpack_public_path__ + "static/assets/c1beb56b1fefeda4648b33f84b76161d.jpg";